<template>
  <component :is="newUi ? 'AppCard' : 'section'" :design="newUi ? 'new' : null" :title="newUi ? title : null" :title-tag="newUi ? 'h3' : null" :class="{ 'automation-detail-card': !newUi, 'automation-detail-card--wide': wide }">
    <template v-if="newUi && $slots['title-help']" #title-help><slot name="title-help" /></template>
    <template v-if="newUi && $slots.actions" #actions><slot name="actions" /></template>
    <header v-if="!newUi" class="automation-detail-card__header">
      <div class="automation-detail-card__title-row">
        <h3>{{ title }}</h3>
        <slot name="title-help" />
      </div>
      <div v-if="$slots.actions" class="automation-detail-card__actions"><slot name="actions" /></div>
    </header>
    <slot />
  </component>
</template>

<script>
export default {
  name: 'FollowUpAutomationDetailCard',
  props: {
    newUi: Boolean,
    title: { type: String, required: true },
    wide: Boolean
  }
}
</script>
